import axios from 'axios';
import store from "../store/index";
import tool from "../tool/index";

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';//配置请求头信息。
axios.defaults.headers.common['token'] = sessionStorage.getItem("ms_token");

const service = axios.create({
    // process.env.NODE_ENV === 'development' //来判断是否开发环境
    baseURL: '/CrmApi/Version',
    // baseURL: (process.env.NODE_ENV === 'development') ? 'http://localhost:9815' : '/CrmApi',
    // baseURL: 'http://localhost:9811/WxLogin',
    timeout: 1000000
});
//发送请求前
service.interceptors.request.use(
    function(config)  {
        // console.time("Request")
        // console.timeLog("Request")
        // config.transformRequest = function (data) {
        //     return data;
        // }
        // config.headers.common['token'] = sessionStorage.getItem("ms_token");
        // console.log(config);
        return config;
    },
    function(error)  {
        console.log(error);
        return Promise.reject(error);
    }
);
//收到请求后
service.interceptors.response.use( 
    function(response)  {
        // response.transformResponse = function (data) {
        //     return data;
        // }
        if (response.status === 200) {
            // console.timeLog("Request")
            // console.timeEnd("Request")
            return {res:response.data,headers:response.headers};
        } else {
            Promise.reject();
        }
    },
    function(error) {
        console.log(error);
        return Promise.reject();
    }
);

export default service;
